(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2305],{

/***/ 83993:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thi-sa-hinh/[licenseType]",
      function () {
        return __webpack_require__(70112);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ PracticalExam; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82771);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85307);
/* harmony import */ var _redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29050);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33599);
/* harmony import */ var _sections_practicalExam_PracticalSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44387);
/* eslint-disable react/prop-types */ /* eslint-disable react-hooks/exhaustive-deps */ 








PracticalExam.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function PracticalExam(param) {
    var licenseType = param.licenseType;
    var urlify = function urlify(text) {
        var anchors = /<img\s[^>]*?src=(["']?)([^\s]+?)\1[^>]*?>/ig;
        var links = [];
        text.replace(anchors, function(_anchor, _quote, url) {
            links.push(url);
        });
        return links === null || links === void 0 ? void 0 : links[0];
    };
    var metaTitle = licenseType.metaTitle, description = licenseType.description, metaDescription = licenseType.metaDescription, practicalExams = licenseType.practicalExams;
    var imagePath = urlify(description);
    var currentItem = (practicalExams === null || practicalExams === void 0 ? void 0 : practicalExams[0]) || null;
    var nextItem = (practicalExams === null || practicalExams === void 0 ? void 0 : practicalExams[1]) || null;
    var ref = (0,_redux_store__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return state.blogComment;
    }), searchComment = ref.search;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_redux_store__WEBPACK_IMPORTED_MODULE_5__/* .dispatch */ .WI)((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_4__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, searchComment), {
            value: "",
            page: 0,
            filterBys: {
                itemId: licenseType.id,
                type: "PRACTICE"
            }
        })));
    }, [
        licenseType
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: metaTitle,
        description: metaDescription,
        imagePath: imagePath,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_practicalExam_PracticalSection__WEBPACK_IMPORTED_MODULE_6__/* .PracticalSection */ .L, {
            licenseType: licenseType,
            nextItem: nextItem,
            currentItem: currentItem
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2544,5101,1160,3362,917,2077,5410,6461,1739,892,1876,1284,3559,4397,2225,723,9774,2888,179], function() { return __webpack_exec__(83993); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);